export type Projection = {
  x: number
  y: number
}

export type PhotoResponse = {
  image_name: string
  width: number
  height: number
  contribution_score: number
  projection: Projection
}

export type WorldPosition = {
  x: number
  y: number
  z: number
}
